module.exports = __webpack_public_path__ + "assets/img/status-warning-wcag.dbbc32b0.svg";